import { GridCellProps } from '@progress/kendo-react-grid';
import { DetailArrowIcon } from 'app/assets/icons';
import { AdminProfileInfo } from 'app/components/AdminProfileInfo';
import styled from 'styled-components';

type Props = {
  className?: string;
  isHideView?: boolean;
  e: GridCellProps;
  onViewClick?: (e) => void;
  title?: string;
  profileClassName?: string;
};

const RiderNameCell = ({ className, e, onViewClick, isHideView, title, profileClassName }: Props) => {
  const data = e.dataItem;
  return (
    <StyledTd
      style={e.style}
      className={e.className}
      onClick={() => onViewClick?.(data)}
    >
      <CustomTableColumnWrapper>
        <AdminProfileInfo
          className={profileClassName ?? ''}
          src={data?.rider?.imageUrl}
          name={data?.rider?.name ? data?.rider?.name : title ? title : ""}
          subLabel={data?.rider?.email}
        />
        {!isHideView && (
          <div>
            <DetailArrowIcon />
          </div>
        )}
      </CustomTableColumnWrapper>
    </StyledTd>
  );
};

export default RiderNameCell;
const StyledTd = styled.td``;
const CustomTableColumnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0 0px;
`;
